var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3239 9.57337C13.325 8.79929 13.1184 8.03917 12.7256 7.37226C12.3326 6.70535 11.768 6.15614 11.0903 5.78195C10.4128 5.40777 9.64718 5.22234 8.87348 5.24502C8.09978 5.2677 7.34634 5.49766 6.69184 5.91089C6.03735 6.32413 5.50578 6.90548 5.15263 7.59427C4.7995 8.28307 4.63772 9.05399 4.68421 9.82664C4.73071 10.5993 4.98376 11.3452 5.41695 11.9867C5.85013 12.6282 6.44758 13.1416 7.14691 13.4734V15.7496H10.8534V13.4749C11.5921 13.1248 12.2163 12.5725 12.6536 11.8819C13.0909 11.1913 13.3233 10.3908 13.3239 9.57337Z",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75041 15.75H8.25041V17.25H9.75041V15.75Z",
    stroke: "#011E1E",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9H15.75",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.24902H2.25",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0V2.25",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25L3.75 3.75",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7496 2.25L14.2496 3.75",
    stroke: "#011E1E",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light_bulb.847505bae0818ef781c5ab05fab48fea.svg";
export { ForwardRef as ReactComponent };